import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy, TemplateRef, ViewEncapsulation, Self } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../../services/auth/auth.service';
import { WindowService } from '../../services/window/window.service';
import { FormsModule, FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable, Subject } from 'rxjs/Rx';
import { User } from '../datamodel/user';
import { ToggleService } from '../../services/toggle/toggle.service';
import { StateService } from '../../services/state/state.service';
import { Provider } from '../../modules/datamodel/provider';
import { Department } from '../../modules/datamodel/department';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent } from 'angular-calendar';
import * as _ from 'underscore';
import Swal from 'sweetalert2';
import { timeout } from 'rxjs/operators/timeout';
import "rxjs/add/operator/take";

import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

const colors: any = {
    red: {
        primary: '#ad2121',
        secondary: '#FAE3E3'
    },
    blue: {
        primary: '#1e90ff',
        secondary: '#D1E8FF'
    },
    yellow: {
        primary: '#e3bc08',
        secondary: '#FDF1BA'
    },
    green: {
        primary: '#07aa09',
        secondary: '#07aa09'
    }
};

interface Schedules {
    type: any;
}
interface scheduleShifts {
    type: any;
}
interface providerSchedules {
    type: any;
}
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'key=AIzaSyBDB_jgKH-eDllQnGWTQJiRmQ2vSS0hKag'
    })
};
function mapSnapshot(changes:any) {
    return changes.map(a => {
        const data = a.payload.doc.data() as User;
        const id = a.payload.doc.id;
        return { id, ...data };
    });
}

@Component({
    selector: 'app-schedules',
    //changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './schedules.component.html',
    styleUrls: ['./schedules.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [WindowService]
})
export class SchedulesComponent implements OnInit {
    //@ViewChild('modalContent') modalContent: TemplateRef<any>;

    view: string = 'month';
    public loading = false;
    viewDate: Date = new Date();
    currDate: Date = new Date();

    refresh: Subject<any> = new Subject();

    activeDayIsOpen: boolean = false;

    public userProfile: object;
    private userRef: AngularFirestoreCollection<User>;
    obsUser: Observable<any>;
    
    private schedulesRef: AngularFirestoreCollection<any>;
    obsSchedules: Observable<any>;

    private shiftsRef: AngularFirestoreCollection<any>;
    obsShifts: Observable<any>;

    private providerShiftsRef: AngularFirestoreCollection<any>;
    obsProviderShifts: Observable<any>;

    private doctorsRef: AngularFirestoreCollection<Provider>;
    obsDoctors: Observable<any>;

    public scheduleList = [];
    public scheduleFList = [];
    public listDoctors = [];
    public shiftsList = [];
    public hospId: string;
    public schedule: object;
    public events_show: boolean = false;
    public showEmptyShifts: boolean = false;
    public selectedInstitution: object;
    private scheduleShiftRef: AngularFirestoreCollection<any>;
    obsScheduleShift: Observable<any>;
    private shiftProvidersRef: AngularFirestoreCollection<any>;
    obsShiftProviders: Observable<any>;
    events: CalendarEvent[] = [];


    popoverTitle: string = 'Are you sure?';
    popoverMessage: string = 'Are you really <b>sure</b> you want to do this?';
    popoverAssignMessage: string = 'Are you really <b>sure</b> you want to assign the selected provider to this shift?';
    popoverBroadcastAllMessage: string = 'Are you really <b>sure</b> you want to broadcast the shift to all the providers?';
    popoverBroadcastMessage: string = 'Are you really <b>sure</b> you want to broadcast the shift to the selected provider?';
    public confirmClicked: boolean = false;
    public cancelClicked: boolean = false;
    public placement: string = 'left';
    public selectedDoctorName: string = '';
    public showDoctorsListPopup: boolean = false;
    public showBroadcastPopup: boolean = false;
    public selProviderScheduleId: string;
    public selectedProviders = [];
    actions: CalendarEventAction[] = [
        {
            label: '<span class="btn btn-primary dropdown-toggle">Broadcast Availability</span>',
            onClick: ({ event }: { event: CalendarEvent }): void => {
                this.handleEvent('Broadcast', event);
            }
        },
        {
            label: '<span class="btn btn-default lmargin10">Assign Doctor</span>',
            onClick: ({ event }: { event: CalendarEvent }): void => {
                this.handleEvent('Assign', event);
            }
        }
    ];
    constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, private fb: FormBuilder, public toggle: ToggleService, private state: StateService, private router: Router, private modal: NgbModal, private spinnerService: Ng4LoadingSpinnerService, public http: HttpClient) {
        this.view = 'week';
        
    }

    getDoctorsList(userHospId) {
        return this.afs.collection('providers', ref => ref.where('credentialedAt.' + userHospId + '.id', '==', userHospId)).snapshotChanges().map(mapSnapshot).take(1);
    }

    getTotalDays(start_date, end_date){
        let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        let firstDate = new Date(start_date);
        let secondDate = new Date(end_date);
        return Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
    }

    getUserProfile() {
        let objUser = firebase.auth().currentUser;
        let self = this;
        this.userRef = this.afs.collection('users', ref => ref.where('email', '==', objUser.email));
        this.obsUser = this.userRef.snapshotChanges().map(changes => {
            
        });
        this.obsUser.subscribe(docs => {
            self.hospId = docs[0].data.adminFor[0].id;
        });

    }

    clearFilter(){
        this.schedule = null;
        this.events = [];
        this.events = this.getSchedulesList();
        this.fetchEvents();
    }

    filterCalendar(schedule){
        this.schedule = schedule;
        this.events = [];
        this.events = this.getSelectedSchedulesList(schedule.id);
        this.fetchEvents();
    }

    CalculateWeekendDays(fromDate, toDate, weekDayKey) {
        if (weekDayKey>6) {
            weekDayKey = weekDayKey%7;
        }
        var start = new Date(fromDate);
        var finish = new Date(toDate);
        var dayMilliseconds = 1000 * 60 * 60 * 24;
        var weekendDays = 0;
        while (start.getTime() <= finish.getTime()) {
            var day = start.getDay();
            if (day == weekDayKey) {
                weekendDays++;
            }
            start = new Date(+start + dayMilliseconds);
        }
        return weekendDays;
    }

    schedulesList() {
        let objUser = firebase.auth().currentUser;
        let result = [];
        let afs = this.afs;
        let self = this;
        let boxTitle = "";
        this.userRef = this.afs.collection('users', ref => ref.where('email', '==', objUser.email));
        this.obsUser = this.userRef.snapshotChanges().map(changes => {
            return changes.map(a => {
                const data = a.payload.doc.data() as User;
                const id = a.payload.doc.id;
                return { "id": id, "data": data };
            });
        });
        this.obsUser.subscribe(docs => {
            this.loading = false;
            self.hospId = docs[0].data.adminFor[0].id;
            self.schedulesRef = afs.collection('schedules', ref => ref.where('instituteRef.id', '==', self.hospId));
            self.obsSchedules = self.schedulesRef.snapshotChanges().map(changes => {
                return changes.map(b => {
                    const bdata = b.payload.doc.data() as Schedules;
                    const bid = b.payload.doc.id;
                    return { bid, ...bdata };
                });
            });

            self.obsSchedules.subscribe(ldocs => {
                self.scheduleList = ldocs;
            });
        });
    }

    dateFormat(dt) {
        dt = new Date(dt);
        let dfm = [
            dt.getFullYear(),
            ('0' + (dt.getMonth() + 1)).slice(-2),
            ('0' + dt.getDate()).slice(-2)
        ].join('-');
        return dfm;
    }

    //events: CalendarEvent[] = [];
    stdate: string;
    /**
     * find out the list of all the schedules and create events into calendar
     */
    getSchedulesList() {
        let objUser = firebase.auth().currentUser;
        let result = [];
        let afs = this.afs;
        let self = this;
        let boxTitle = {};
        let boxDoctors = {};
        let totalDocs = {};
        let totalShiftDocs = {};
        this.view = 'month';
        let obSchedules = [];
        let totalReqDoctors = {};
        let totalAvailDoctors = {};
        /**
         * Get users list
         */
        const userRef = this.afs.collection('users').doc(objUser.uid);
        userRef.valueChanges().subscribe(user => {
            //Get user hospital
            const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
                ? user['adminFor'][0].id : '';

            //get schedules of hospitals
            self.schedulesRef = afs.collection('schedules', ref => ref.where('instituteRef.id', '==', userHospId).orderBy('name','asc'));
            self.schedulesRef.snapshotChanges().map(mapSnapshot).subscribe(schedules => {
                //console.log(schedules);
                let promiseArr = [];
                self.scheduleList = schedules;
                self.scheduleFList = schedules;
                if (schedules && schedules.length > 0){
                    schedules.forEach(schedule => {
                        obSchedules.push({ id: schedule.id, name: schedule.name });
                        let promise = new Promise(function(resolve, reject) {
                            self.shiftsRef = afs.collection('schedules_shifts', ref => ref.where('scheduleRef.id', '==', schedule.id).orderBy('day', 'asc'));
                            self.shiftsRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(scheduleShifts => {
                                //console.log(scheduleShifts);
                                if(scheduleShifts && scheduleShifts.length > 0){
                                    let _scheduleShifts2 = [];
                                    scheduleShifts.forEach(function (scheduleShift) {
                                        scheduleShift['schedule'] = schedule;
                                        _scheduleShifts2.push(scheduleShift);
                                    });
                                    resolve(_scheduleShifts2)
                                }else{
                                    reject('no shifts');
                                }    
                            });
                        });
                        promiseArr.push(promise);
                    });
                }
                if(promiseArr.length > 0){
                    Promise.all(promiseArr)
                    .then(scheduleShifts => {
                        //console.log(scheduleShifts);
                        let _scheduleShifts = [];
                        if (scheduleShifts && scheduleShifts.length > 0) {
                            scheduleShifts.forEach(scheduleShift => {
                                _scheduleShifts = _scheduleShifts.concat(scheduleShift);
                            })
                        }
                        //console.log(_scheduleShifts);
                        let promiseArr2 = [];
                        if (_scheduleShifts && _scheduleShifts.length > 0) {
                            var t = 0;
                            let obDoctors = {};
                            let boxProviderSdls = {};
                            _scheduleShifts.forEach(_scheduleShift => {
                                //totalReqDoctors = parseInt(_scheduleShift.total_docs);
                                //totalShiftDocs[_scheduleShift.day] = parseInt(_scheduleShift.total_docs);
                                if (totalShiftDocs[_scheduleShift.day] && typeof totalShiftDocs[_scheduleShift.day] !== "undefined" && totalShiftDocs[_scheduleShift.day] !== "undefined" && parseInt(totalShiftDocs[_scheduleShift.day]) > 0) {
                                    totalShiftDocs[_scheduleShift.day] = parseInt(totalShiftDocs[_scheduleShift.day]) + parseInt(_scheduleShift.total_docs);
                                    totalReqDoctors[_scheduleShift.day] = parseInt(totalReqDoctors[_scheduleShift.day]) + 1;//parseInt(_scheduleShift.total_docs);
                                } else {
                                    totalShiftDocs[_scheduleShift.day] = parseInt(_scheduleShift.total_docs);
                                    totalReqDoctors[_scheduleShift.day] = 1;//parseInt(_scheduleShift.total_docs);
                                }

                                boxTitle[_scheduleShift.schedule.id] = 'Schedule: ' + _scheduleShift.schedule.name + '<br>Department: ' + _scheduleShift.department + '<br>Shift Type: ' + _scheduleShift.shift_type + '<br>Doc Type: ' + _scheduleShift.doc_type;
                                
                                let docImage = '../../assets/img/provider.png';

                                let _promise = new Promise(function(resolve, reject){
                                    self.providerShiftsRef = afs.collection('provider_schedules', ref => ref.where('shift.id', '==', _scheduleShift.id).orderBy('shift_date', 'asc'));
                                    self.providerShiftsRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(shifts => {
                                        let _promiseArr = [];
                                        if (shifts.length > 0) {
                                            shifts.forEach(function (shift, index) {
                                                //console.log(shift);
                                                //create doctors info tooltip
                                                //boxTitle[_scheduleShift.schedule.id] += '<br>' + shift.id;
                                                boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] = '<br>';

                                                let _promise = new Promise(function (_resolve, _reject) {
                                                    if (shift.provider.ref !== ''){
                                                        shift.provider.ref.get().then(doc => {
                                                            //console.log(doc);
                                                            if (doc.exists) {
                                                                let bgcolor = colors.green;
                                                                if (totalAvailDoctors[shift.shift_date_format] && typeof totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] > 0) {
                                                                    totalAvailDoctors[shift.shift_date_format] = parseInt(totalAvailDoctors[shift.shift_date_format]) + 1;
                                                                } else {
                                                                    totalAvailDoctors[shift.shift_date_format] = 1;
                                                                }
                                                                
                                                                shift['provider'] = doc.data();
                                                                shift['scheduleShift'] = _scheduleShift;
                                                                if (shift['provider'].photo == '') {
                                                                    shift['provider'].photo = docImage;
                                                                }
                                                                //concat doctors info into box
                                                                boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] += '<ul class="doclist inline-item"><li><a class="whtText"><img src="' + shift['provider'].photo + '" /><span class="name">' + shift['provider'].first_name + ' ' + shift['provider'].last_name + '</span></a></li></ul>';
                                                                //push into doctor array

                                                                let key = shift.shift.id + '_' + shift.shift_timestamp;
                                                                //let key = shift.shift_date_format;
                                                                if (!obDoctors[key]) {
                                                                    obDoctors[key] = [];
                                                                }
                                                                if (!boxProviderSdls[key]) {
                                                                    boxProviderSdls[key] = [];
                                                                }
                                                                obDoctors[key].push({
                                                                    id: shift.provider.id,
                                                                    name: shift['provider'].first_name + ' ' + shift['provider'].last_name,
                                                                    photo: shift['provider'].photo
                                                                });
                                                                boxProviderSdls[key].push({ id: shift.id, swap_request: shift.swap_request });
                                                                //push into result array
                                                                result.push({
                                                                    start: startOfDay(shift.shift_date),
                                                                    end: endOfDay(shift.shift_date),
                                                                    date_format:self.dateFormat(shift.shift_date),
                                                                    psid: shift.id,
                                                                    schedules: obSchedules,
                                                                    day: shift.day,
                                                                    title: boxTitle[_scheduleShift.schedule.id] + boxDoctors[shift.shift.id + '_' + shift.shift_timestamp],
                                                                    schedule: _scheduleShift.schedule.name,
                                                                    totalDocs: totalShiftDocs[_scheduleShift.day],
                                                                    doctors: obDoctors[key],
                                                                    provider_schedules: boxProviderSdls[key],
                                                                    color: bgcolor,
                                                                    totalReqDoctors: totalReqDoctors[_scheduleShift.day],
                                                                    totalAvailDoctors: totalAvailDoctors[shift.shift_date_format],
                                                                    resizable: {
                                                                        beforeStart: true,
                                                                        afterEnd: true
                                                                    },
                                                                    draggable: false
                                                                });


                                                            } else{

                                                            }
                                                        })
                                                        .catch(err => _reject(err));
                                                    }else {
                                                        let bgcolor = colors.green;
                                                        if(totalAvailDoctors[shift.shift_date_format] && typeof totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] > 0) {
                                                        } else {
                                                            totalAvailDoctors[shift.shift_date_format] = 0;
                                                        }
                                                        // boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] = '<br><a class="btn btn-primary" (click)="broadcast_availability(_scheduleShift.schedule.id, shift.shift.id, shift.shift_date);">Broadcast Availability</a>';
                                                        boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] = '<br>';
                                                        var obDoctor = [];
                                                        //push into result array
                                                        result.push({
                                                            start: startOfDay(shift.shift_date),
                                                            end: endOfDay(shift.shift_date),
                                                            date_format: self.dateFormat(shift.shift_date),
                                                            psid: shift.id,
                                                            schedules: obSchedules,
                                                            day: shift.day,
                                                            title: boxTitle[_scheduleShift.schedule.id] + boxDoctors[shift.shift.id + '_' + shift.shift_timestamp],
                                                            schedule: _scheduleShift.schedule.name,
                                                            totalDocs: totalShiftDocs[_scheduleShift.day],
                                                            doctors: [],
                                                            color: bgcolor,
                                                            totalReqDoctors: totalReqDoctors[_scheduleShift.day],
                                                            totalAvailDoctors: totalAvailDoctors[shift.shift_date_format],
                                                            resizable: {
                                                                beforeStart: true,
                                                                afterEnd: true
                                                            },
                                                            actions: self.actions,
                                                            draggable: false
                                                        });
                                                    }
                                                    _resolve(result);
                                                })
                                                
                                            });
                                            t++;
                                            _promiseArr.push(_promise);
                                        }
                                        Promise.all(_promiseArr).then(res => resolve(res)).catch(err => reject(err));
                                    });
                                });
                            });
                        }
                        Promise.all(promiseArr2).then(shifts => {
                            let _shifts = [];
                            if (shifts && shifts.length > 0) {
                                shifts.forEach(function (shift) {
                                    _shifts = _shifts.concat(shift);
                                });
                            }
                            this.view = 'month';
                        })
                        .catch();
                    })
                    .catch( err => console.log(err))
                }
            });
        });
        console.log(result);
        // this.spinnerService.hide();
        return result;
    }

    /**
     * find out the details/shifts of selected schedule and create events into calendar
     */
    getSelectedSchedulesList(sdlId) {
        let objUser = firebase.auth().currentUser;
        let result = [];
        let afs = this.afs;
        let self = this;
        let boxTitle = {};
        let boxDoctors = {};
        let totalDocs = {};
        let totalShiftDocs = {};
        this.view = 'month';
        let obSchedules = [];
        let totalReqDoctors = {};
        let totalAvailDoctors = {};
        /**
         * Get users list
         */
        const userRef = this.afs.collection('users').doc(objUser.uid);
        userRef.valueChanges().subscribe(user => {
            //Get user hospital
            const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
                ? user['adminFor'][0].id : '';

            //get schedules of hospitals
            const schedulesRef = afs.collection('schedules').doc(sdlId);
            schedulesRef.valueChanges().subscribe(schedule => {
                //self.scheduleList.push(schedule);
                let promiseArr = [];
                if (schedule) {
                    console.log(schedule);
                    obSchedules.push({ id: sdlId, name: schedule['name'] });
                    //console.log(obSchedules);
                    let promise = new Promise(function (resolve, reject) {
                        self.shiftsRef = afs.collection('schedules_shifts', ref => ref.where('scheduleRef.id', '==', sdlId).orderBy('day', 'asc'));
                        self.shiftsRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(scheduleShifts => {
                            if (scheduleShifts && scheduleShifts.length > 0) {
                                let _scheduleShifts = [];
                                scheduleShifts.forEach(function (scheduleShift) {
                                    scheduleShift['schedule'] = schedule;
                                    _scheduleShifts.push(scheduleShift);
                                });
                                resolve(_scheduleShifts)
                            } else {
                                reject('no shifts');
                            }
                        });
                    });
                    promiseArr.push(promise);

                }
                if (promiseArr.length > 0) {
                    Promise.all(promiseArr)
                        .then(scheduleShifts => {
                            //console.log(scheduleShifts);
                            let _scheduleShifts = [];
                            if (scheduleShifts && scheduleShifts.length > 0) {
                                scheduleShifts.forEach(scheduleShift => {
                                    _scheduleShifts = _scheduleShifts.concat(scheduleShift);
                                })
                            }
                            //console.log(_scheduleShifts);
                            let promiseArr2 = [];
                            if (_scheduleShifts && _scheduleShifts.length > 0) {
                                var t = 0;
                                let obDoctors = {};
                                let boxProviderSdls = {};
                                _scheduleShifts.forEach(_scheduleShift => {
                                    //totalReqDoctors = parseInt(_scheduleShift.total_docs);
                                    //totalShiftDocs[_scheduleShift.day] = parseInt(_scheduleShift.total_docs);
                                    if (totalShiftDocs[_scheduleShift.day] && typeof totalShiftDocs[_scheduleShift.day] !== "undefined" && totalShiftDocs[_scheduleShift.day] !== "undefined" && parseInt(totalShiftDocs[_scheduleShift.day]) > 0) {
                                        totalShiftDocs[_scheduleShift.day] = parseInt(totalShiftDocs[_scheduleShift.day]) + parseInt(_scheduleShift.total_docs);
                                        totalReqDoctors[_scheduleShift.day] = parseInt(totalReqDoctors[_scheduleShift.day]) + 1;//parseInt(_scheduleShift.total_docs);
                                    } else {
                                        totalShiftDocs[_scheduleShift.day] = parseInt(_scheduleShift.total_docs);
                                        totalReqDoctors[_scheduleShift.day] = 1;//parseInt(_scheduleShift.total_docs);
                                    }

                                    boxTitle[_scheduleShift.schedule.id] = 'Schedule: ' + _scheduleShift.schedule.name + '<br>Department: ' + _scheduleShift.department + '<br>Shift Type: ' + _scheduleShift.shift_type + '<br>Doc Type: ' + _scheduleShift.doc_type;

                                    let docImage = '../../assets/img/provider.png';

                                    let _promise = new Promise(function (resolve, reject) {
                                        self.providerShiftsRef = afs.collection('provider_schedules', ref => ref.where('shift.id', '==', _scheduleShift.id).orderBy('shift_date', 'asc'));
                                        self.providerShiftsRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(shifts => {
                                            let _promiseArr = [];
                                            if (shifts.length > 0) {
                                                shifts.forEach(function (shift, index) {
                                                    //console.log(shift);
                                                    //create doctors info tooltip
                                                    //boxTitle[_scheduleShift.schedule.id] += '<br>' + shift.id;
                                                    boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] = '<br>';

                                                    let _promise = new Promise(function (_resolve, _reject) {
                                                        if (shift.provider.ref !== '') {
                                                            shift.provider.ref.get().then(doc => {
                                                                //console.log(doc);
                                                                if (doc.exists) {
                                                                    let bgcolor = colors.green;
                                                                    if (totalAvailDoctors[shift.shift_date_format] && typeof totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] > 0) {
                                                                        totalAvailDoctors[shift.shift_date_format] = parseInt(totalAvailDoctors[shift.shift_date_format]) + 1;
                                                                    } else {
                                                                        totalAvailDoctors[shift.shift_date_format] = 1;
                                                                    }

                                                                    shift['provider'] = doc.data();
                                                                    shift['scheduleShift'] = _scheduleShift;
                                                                    if (shift['provider'].photo == '') {
                                                                        shift['provider'].photo = docImage;
                                                                    }
                                                                    //concat doctors info into box
                                                                    boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] += '<ul class="doclist inline-item"><li><a class="whtText"><img src="' + shift['provider'].photo + '" /><span class="name">' + shift['provider'].first_name + ' ' + shift['provider'].last_name + '</span></a></li></ul>';
                                                                    //push into doctor array

                                                                    let key = shift.shift.id + '_' + shift.shift_timestamp;
                                                                    //let key = shift.shift_date_format;
                                                                    if (!obDoctors[key]) {
                                                                        obDoctors[key] = [];
                                                                    }
                                                                    if (!boxProviderSdls[key]) {
                                                                        boxProviderSdls[key] = [];
                                                                    }
                                                                    obDoctors[key].push({
                                                                        id: shift.provider.id,
                                                                        name: shift['provider'].first_name + ' ' + shift['provider'].last_name,
                                                                        photo: shift['provider'].photo
                                                                    });
                                                                    boxProviderSdls[key].push({ id: shift.id, swap_request: shift.swap_request });
                                                                    //push into result array
                                                                    result.push({
                                                                        start: startOfDay(shift.shift_date),
                                                                        end: endOfDay(shift.shift_date),
                                                                        date_format: self.dateFormat(shift.shift_date),
                                                                        psid: shift.id,
                                                                        schedules: obSchedules,
                                                                        day: shift.day,
                                                                        title: boxTitle[_scheduleShift.schedule.id] + boxDoctors[shift.shift.id + '_' + shift.shift_timestamp],
                                                                        schedule: _scheduleShift.schedule.name,
                                                                        totalDocs: totalShiftDocs[_scheduleShift.day],
                                                                        doctors: obDoctors[key],
                                                                        provider_schedules: boxProviderSdls[key],
                                                                        color: bgcolor,
                                                                        totalReqDoctors: totalReqDoctors[_scheduleShift.day],
                                                                        totalAvailDoctors: totalAvailDoctors[shift.shift_date_format],
                                                                        resizable: {
                                                                            beforeStart: true,
                                                                            afterEnd: true
                                                                        },
                                                                        draggable: false
                                                                    });


                                                                } else {

                                                                }
                                                            })
                                                                .catch(err => _reject(err));
                                                        } else {
                                                            let bgcolor = colors.green;
                                                            if (totalAvailDoctors[shift.shift_date_format] && typeof totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] > 0) {
                                                            } else {
                                                                totalAvailDoctors[shift.shift_date_format] = 0;
                                                            }
                                                            // boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] = '<br><a class="btn btn-primary" (click)="broadcast_availability(_scheduleShift.schedule.id, shift.shift.id, shift.shift_date);">Broadcast Availability</a>';
                                                            boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] = '<br>';
                                                            var obDoctor = [];
                                                            //push into result array
                                                            result.push({
                                                                start: startOfDay(shift.shift_date),
                                                                end: endOfDay(shift.shift_date),
                                                                date_format: self.dateFormat(shift.shift_date),
                                                                psid: shift.id,
                                                                schedules: obSchedules,
                                                                day: shift.day,
                                                                title: boxTitle[_scheduleShift.schedule.id] + boxDoctors[shift.shift.id + '_' + shift.shift_timestamp],
                                                                schedule: _scheduleShift.schedule.name,
                                                                totalDocs: totalShiftDocs[_scheduleShift.day],
                                                                doctors: [],
                                                                color: bgcolor,
                                                                totalReqDoctors: totalReqDoctors[_scheduleShift.day],
                                                                totalAvailDoctors: totalAvailDoctors[shift.shift_date_format],
                                                                resizable: {
                                                                    beforeStart: true,
                                                                    afterEnd: true
                                                                },
                                                                actions: self.actions,
                                                                draggable: false
                                                            });
                                                        }
                                                        _resolve(result);
                                                    })

                                                });
                                                t++;
                                                _promiseArr.push(_promise);
                                            }
                                            Promise.all(_promiseArr).then(res => resolve(res)).catch(err => reject(err));
                                        });
                                    });
                                });
                            }
                            Promise.all(promiseArr2).then(shifts => {
                                let _shifts = [];
                                if (shifts && shifts.length > 0) {
                                    shifts.forEach(function (shift) {
                                        _shifts = _shifts.concat(shift);
                                    });
                                }
                                this.view = 'month';
                            })
                            .catch();
                        })
                        .catch(err => console.log(err))
                }  
            });
        });
        console.log(result);
        //this.spinnerService.hide();
        return result;
    }
    
    //delete provider from shift
    removeDoctor(scheduleId, scheduleShiftId, doctor) {
        let self = this;
        let newPvdList = [];
        let count = 0;
        var hospId = self.selectedInstitution['id'];
        var hospRef = this.afs.doc('institutions/' + hospId);
        var sdlRef = this.afs.doc('schedules/' + scheduleId);
        self.spinnerService.show();
        const shiftDocument: AngularFirestoreDocument<any> = self.afs.doc('schedules_shifts/' + scheduleShiftId);
        const shiftDocument$: Observable<any> = shiftDocument.valueChanges();
        shiftDocument$.take(1).subscribe(scheduleShift => {
            if (scheduleShift) {
                var day = parseInt(scheduleShift.day) % 7;
                var shiftDoc = this.afs.doc('schedules_shifts/' + scheduleShiftId);
                self.afs.collection('schedules_shifts').doc(scheduleShiftId).update({
                    provider: {
                        id: '',
                        ref: ''
                    },
                    modified: new Date()
                }).then(function (val) {
                    self.shiftProvidersRef = self.afs.collection('provider_schedules', ref => ref.where('provider.id', '==', doctor.id + '').where('shift.id', '==', scheduleShiftId + ''));
                    self.shiftProvidersRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(pvdshifts => {
                        console.log(pvdshifts);
                        if (pvdshifts && pvdshifts.length > 0) {
                            let count = 1;
                            pvdshifts.forEach(pvdshift => {
                                console.log(pvdshift);
                                self.afs.collection("provider_schedules").doc(pvdshift.id).update({
                                    provider: {
                                        id: '',
                                        ref: ''
                                    },
                                    modified: new Date()
                                });
                                count++;
                            });
                            if (count >= pvdshifts.length) {
                                const docRefc = self.afs.doc('providers/' + doctor.id);
                                const document: AngularFirestoreDocument<any> = self.afs.doc('providers/' + doctor.id);
                                const document$: Observable<any> = document.valueChanges();
                                document$.take(1).subscribe(sdata => {
                                    //self.getScheduleDetails(self.activeId);
                                    let objUser = firebase.auth().currentUser;

                                    self.afs.collection("admin_logs").add({
                                        user_id: objUser.uid,
                                        provider: {
                                            id: doctor.id,
                                            ref: docRefc.ref
                                        },
                                        content: 'Removed ' + sdata.first_name + ' ' + sdata.last_name + ' from schedule',
                                        type: 'remove_doctor_shift',
                                        data: { provider_id: doctor.id, shift_id: scheduleShiftId, schedule_id: scheduleId },
                                        created: firebase.firestore.FieldValue.serverTimestamp()
                                    }).then(function (cres) {
                                        self.spinnerService.hide();
                                    });

                                    const idocument: AngularFirestoreDocument<any> = self.afs.doc('institutions/' + hospId);
                                    const idocument$: Observable<any> = idocument.valueChanges();
                                    idocument$.take(1).subscribe(hspdata => {
                                        var nTitle = "Shift update";
                                        var nMessage = hspdata.name + ' has removed ' + sdata.first_name + ' ' + sdata.last_name + ' from shift.';
                                        if (sdata.device && sdata.device.deviceToken) {
                                            let nmessage = {
                                                "notification": {
                                                    "title": 'assign_shift',
                                                    "body": nMessage,
                                                    "sound": "default",
                                                    "click_action": "FCM_PLUGIN_ACTIVITY",
                                                    "icon": "fcm_push_icon"
                                                },
                                                "data": {
                                                    "param1": "value1",
                                                    "param2": "value2"
                                                },
                                                "to": sdata.device.deviceToken,
                                                "priority": "high",
                                                "restricted_package_name": ""
                                            };
                                            //console.log(nmessage);
                                            self.http
                                                .post('https://fcm.googleapis.com/fcm/send', nmessage, httpOptions)
                                                .subscribe(ntdata => {
                                                    //console.log(data);
                                                    //add notification collection
                                                    self.afs.collection('md_notifications').add({
                                                        created_at: firebase.firestore.FieldValue.serverTimestamp(),
                                                        institute: {
                                                            id: hospId,
                                                            ref: hospRef.ref
                                                        },
                                                        provider: {},
                                                        type: 'assign_shift',
                                                        schedule: {
                                                            id: scheduleId,
                                                            ref: sdlRef.ref
                                                        },
                                                        recipient: {
                                                            id: doctor.id,
                                                            ref: docRefc.ref
                                                        },
                                                        message: { body: nMessage, title: nTitle },
                                                        status: true
                                                    });
                                                    self.spinnerService.hide();
                                                });
                                        } else {
                                            self.spinnerService.hide();
                                        }
                                    });
                                });
                            }
                        }
                    });
                });
            }

        });
    }
    
    ngOnInit() {
        this.schedule = null;
        this.spinnerService.show();
        this.fetchEvents();
        var dt = new Date();
        this.events = this.getSchedulesList();
        this.refresh.next();
    }

    showLoader(): void {
        this.spinnerService.show();
        setTimeout(() => {
            console.log("hide loader")
            this.spinnerService.hide();
        }, 5000);
    }

    fetchEvents(): void {
        let self = this;
        self.spinnerService.show();
        setTimeout(() => {
            this.loading = false;
            //this.view = 'month';
            this.refresh.next();
            self.spinnerService.hide();
        }, 5000);
    }
    
    dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
        if (isSameMonth(date, this.viewDate)) {
            if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
                this.activeDayIsOpen = false;
            } else {
                this.activeDayIsOpen = true;
                this.viewDate = date;
            }
        }
    }

    eventTimesChanged({
        event,
        newStart,
        newEnd
  	}: CalendarEventTimesChangedEvent): void {
        event.start = newStart;
        event.end = newEnd;
        this.handleEvent('Dropped or resized', event);
        this.refresh.next();
    }

    closeModal() {
        console.log("close model");
        this.showDoctorsListPopup = false;
        this.showBroadcastPopup = false;
        this.selProviderScheduleId = '';
    }

    assignDoctor(doctor) {
        let self = this;
        let objUser = firebase.auth().currentUser;
        this.spinnerService.show();
        const sdocument: AngularFirestoreDocument<any> = self.afs.doc('provider_schedules/' + this.selProviderScheduleId);
        const sdocument$: Observable<any> = sdocument.valueChanges();
        sdocument$.take(1).subscribe(pshift => {
            if (pshift){
                var scheduleShiftId = pshift.shift.id;
                var userHospId = pshift.instituteRef.id;
                let docRefc = self.afs.doc('providers/' + doctor.id);
                let userHospRef = self.afs.doc('institutions/' + userHospId);
                let sdlRef = self.afs.doc('schedules_shifts/' + scheduleShiftId);

                self.afs.collection('schedules_shifts').doc(scheduleShiftId).update({
                    provider: {
                        id: doctor.id,
                        ref: docRefc.ref
                    }
                }).then(function (val) {
                    self.afs.collection("provider_schedules").doc(self.selProviderScheduleId).update({
                        provider: {
                            id: doctor.id,
                            ref: docRefc.ref
                        },
                        modified: new Date()
                    }).then(function (res) {
                        self.spinnerService.hide();
                        Swal({
                            type: 'success',
                            title: 'Provider has been assigned for selected date.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        self.selProviderScheduleId = '';
                        self.activeDayIsOpen = false;
                        self.showDoctorsListPopup = false;
                        self.events = self.getSchedulesList();
                        self.fetchEvents();
                        const idocument: AngularFirestoreDocument<any> = self.afs.doc('institutions/' + userHospId);
                        const idocument$: Observable<any> = idocument.valueChanges();
                        idocument$.subscribe(hspdata => {
                            var nTitle = "You have been assigned a shift";
                            var nMessage = hspdata.name + " has assigned a shift to " + doctor.first_name + " " + doctor.last_name + ".";
                            if (doctor.device && doctor.device.deviceToken) {
                                let nmessage = {
                                    "notification": {
                                        "title": 'assign_shift',
                                        "body": nMessage,
                                        "sound": "default",
                                        "click_action": "FCM_PLUGIN_ACTIVITY",
                                        "icon": "fcm_push_icon"
                                    },
                                    "data": {
                                        "param1": "value1",
                                        "param2": "value2"
                                    },
                                    "to": doctor.device.deviceToken,
                                    "priority": "high",
                                    "restricted_package_name": ""
                                };
                                //console.log(nmessage);
                                self.http
                                    .post('https://fcm.googleapis.com/fcm/send', nmessage, httpOptions)
                                    .subscribe(ntdata => {
                                        var objr = {};
                                        objr[doctor.id] = true;
                                        //add notification collection
                                        self.afs.collection('notifications').add({
                                            created_at: firebase.firestore.FieldValue.serverTimestamp(),
                                            institute: {
                                                id: userHospId,
                                                ref: userHospRef.ref
                                            },
                                            provider: {
                                                id: doctor.id,
                                                ref: docRefc.ref
                                            },
                                            type: 'assign_shift',
                                            schedule: {
                                                id: pshift.schedule.id,
                                                ref: sdlRef.ref
                                            },
                                            recipients: {},
                                            message: { body: nMessage, title: nTitle },
                                            status: '1'
                                        });
                                    });
                            }

                        });
                    });

                });
            }else{
                self.spinnerService.hide();
                Swal({
                    type: 'error',
                    title: 'Oops...',
                    text: 'Something went wrong!'
                });
            }

        });
    }
 
    handleEvent(action: string, event: CalendarEvent): void {
        console.log("action: " + action);
        console.log(event);
        var self = this;
        if (action == 'Assign'){
            this.listDoctors = [];
            self.showBroadcastPopup = false;
            this.selProviderScheduleId = event['psid'];
            let objUser = firebase.auth().currentUser;
            const userRef = this.afs.collection('users').doc(objUser.uid);
            userRef.valueChanges().subscribe(user => {
                //Get user hospital
                const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id) ? user['adminFor'][0].id : '';
                this.getDoctorsList(userHospId).subscribe(docs => {
                    this.listDoctors = docs;
                    this.showDoctorsListPopup = true;
                });
            });
        } else if (action == 'Broadcast') {
            this.listDoctors = [];
            this.showDoctorsListPopup = false;
            self.showBroadcastPopup = true;
            this.selProviderScheduleId = event['psid'];
            let objUser = firebase.auth().currentUser;
            const userRef = this.afs.collection('users').doc(objUser.uid);
            userRef.valueChanges().subscribe(user => {
                //Get user hospital
                const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id) ? user['adminFor'][0].id : '';
                self.getDoctorsList(userHospId).subscribe(docs => {
                    if(docs.length > 0){
                        for(let pvd of docs){
                            //check provider is working or not
                            var pdshiftRef = self.afs.collection('provider_schedules', ref => ref.where('provider.id', '==', pvd.id).where('shift_date_format', '==', event['date_format']));
                            pdshiftRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(providerShifts => {
                                if (providerShifts.length > 0){

                                }else{
                                    self.listDoctors.push(pvd);
                                }
                            });
                        }
                    }
                    console.log(self.listDoctors);
                    if (self.listDoctors.length > 0){
                        self.showBroadcastPopup = true;
                    }
                });
            });
        }
    }

    
    setSelectedProvider(p){
        let index = this.selectedProviders.findIndex(_p => _p.id == p.id);
        if(index >=0 ){
            this.selectedProviders.splice(index,1);
        }else {
            this.selectedProviders.push(p);
        }
        console.log('this.selectedProviders',this.selectedProviders);
    }

    broadcastShiftToProvider(popt){
        if(popt == 'selected'){
            var selectedProviders = this.selectedProviders;
        }else{
            var selectedProviders = this.listDoctors;
        }
        if (selectedProviders.length > 0) {
            let self = this;
            //check if already broadcasted for the selected schedule
            let psNotRef = self.afs.collection('notifications', ref => ref.where('provider_schedule.id', '==', self.selProviderScheduleId).where('type', '==', 'shift_request'));
            psNotRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(notifications => {
                console.log(notifications);
                var selProviderScheduleId = self.selProviderScheduleId;
                var providerScheduleRef = self.afs.doc('provider_schedules/' + self.selProviderScheduleId);
                this.spinnerService.show();
                const sdocument: AngularFirestoreDocument<any> = self.afs.doc('provider_schedules/' + self.selProviderScheduleId);
                const sdocument$: Observable<any> = sdocument.valueChanges();
                sdocument$.take(1).subscribe(pshift => {
                    if (pshift) {
                        var userHospId = pshift.instituteRef.id;
                        var scheduleId = pshift.schedule.id;
                        var nTitle = "Open Shift Available";
                        const idocument: AngularFirestoreDocument<any> = self.afs.doc('institutions/' + userHospId);
                        const idocument$: Observable<any> = idocument.valueChanges();
                        idocument$.take(1).subscribe(hspdata => {
                            var nMessage = hspdata.name + " invited you to work a shift on " + self.dateFormat(pshift.shift_date) + ".";
                            var count = 1;
                            for (let ldoc of selectedProviders) {
                                console.log(ldoc);
                                var providerRef = self.afs.doc('providers/' + ldoc.id);
                                var pvdid = ldoc.id;
                                if (ldoc.device && ldoc.device.deviceToken) {
                                    let message = {
                                        "notification": {
                                            "title": nTitle,
                                            "body": nMessage,
                                            "sound": "default",
                                            "click_action": "FCM_PLUGIN_ACTIVITY",
                                            "icon": "fcm_push_icon"
                                        },
                                        "data": {
                                            "param1": "value1",
                                            "param2": "value2"
                                        },
                                        "to": ldoc.device.deviceToken,
                                        "priority": "high",
                                        "restricted_package_name": ""
                                    };

                                    self.http.post('https://fcm.googleapis.com/fcm/send', message, httpOptions).subscribe(fcm => {
                                    });
                                    count++;
                                } else {
                                    count++;
                                }
                                
                                if (count > selectedProviders.length) {
                                    let recipients = {};
                                    let recipient_details = {};
                                    selectedProviders.map(s => {
                                        recipients[s.id] = true;
                                        recipient_details[s.id] = {
                                            request_from: 'admin',
                                            request_date: new Date()
                                        };
                                        return s;
                                    });

                                    
                                    if(notifications && notifications.length > 0){
                                        for (let r in notifications[0].recipients){
                                            recipients[r] = true;
                                            recipient_details[r] = {
                                                request_from: 'admin',
                                                request_date: new Date()
                                            };
                                        }
                                        console.log(recipients);
                                        
                                        self.afs.collection('notifications').doc(notifications[0].id).update({
                                            modified_at: new Date(),
                                            recipients: recipients,
                                            recipient_details: recipient_details
                                        }).then(function (ares) {
                                            self.spinnerService.hide();
                                            Swal({
                                                type: 'success',
                                                title: 'Provider has been notified for selected date.',
                                                showConfirmButton: true,
                                                timer: 1500
                                            }).then(function (res) {
                                                self.selectedProviders = [];
                                            });
                                            self.selProviderScheduleId = '';
                                            self.activeDayIsOpen = false;
                                            self.showBroadcastPopup = false;
                                        });
                                    }else{
                                        self.afs.collection('notifications').add({
                                            created_at: new Date(),
                                            institute: pshift.instituteRef,
                                            message: { body: nMessage, title: nTitle },
                                            provider: {},
                                            recipients: recipients,
                                            recipient_details: recipient_details,
                                            schedule: pshift.schedule,
                                            provider_schedule: {
                                                id: selProviderScheduleId,
                                                ref: providerScheduleRef.ref
                                            },
                                            shift_date: pshift.shift_date,
                                            status: 1,
                                            type: 'shift_request',
                                            shift_request_status: 'pending',
                                            request_from: 'admin'
                                        }).then(function(ares){
                                            self.spinnerService.hide();
                                            Swal({
                                                type: 'success',
                                                title: 'Provider has been notified for selected date.',
                                                showConfirmButton: true,
                                                timer: 1500
                                            }).then(function (res) {
                                                self.selectedProviders = [];
                                            });
                                            self.selProviderScheduleId = '';
                                            self.activeDayIsOpen = false;
                                            self.showBroadcastPopup = false;
                                        });
                                    }
                                    
                                }
                            }
                        });
                    }
                });
            });
            /* var selProviderScheduleId = this.selProviderScheduleId;
            var providerScheduleRef = self.afs.doc('provider_schedules/' + this.selProviderScheduleId);
            this.spinnerService.show();
            const sdocument: AngularFirestoreDocument<any> = self.afs.doc('provider_schedules/' + this.selProviderScheduleId);
            const sdocument$: Observable<any> = sdocument.valueChanges();
            sdocument$.take(1).subscribe(pshift => {
                if (pshift) {
                    var userHospId = pshift.instituteRef.id;
                    var scheduleId = pshift.schedule.id;
                    var nTitle = "Shift Request";
                    const idocument: AngularFirestoreDocument<any> = self.afs.doc('institutions/' + userHospId);
                    const idocument$: Observable<any> = idocument.valueChanges();
                    idocument$.take(1).subscribe(hspdata => {
                        var nMessage = hspdata.name + " invited you to join a shift on " + self.dateFormat(pshift.shift_date) + ".";
                        var count = 1;
                        for (let ldoc of selectedProviders) {
                            console.log(ldoc);
                            var providerRef = self.afs.doc('providers/' + ldoc.id);
                            var pvdid = ldoc.id;
                            if (ldoc.device && ldoc.device.deviceToken) {
                                let message = {
                                    "notification": {
                                        "title": nTitle,
                                        "body": nMessage,
                                        "sound": "default",
                                        "click_action": "FCM_PLUGIN_ACTIVITY",
                                        "icon": "fcm_push_icon"
                                    },
                                    "data": {
                                        "param1": "value1",
                                        "param2": "value2"
                                    },
                                    "to": ldoc.device.deviceToken,
                                    "priority": "high",
                                    "restricted_package_name": ""
                                };
                            
                                self.http.post('https://fcm.googleapis.com/fcm/send', message, httpOptions).subscribe(fcm => {
                                });
                                count++;
                            } else {
                                
                                count++;
                            }

                        }
                        if (count >= selectedProviders.length) {
                            let recipients = {};
                            selectedProviders.map(s => {
                                recipients[ s.id ] = true;  
                                return s;
                            });
                            self.afs.collection('notifications').add({
                                created_at: new Date(),
                                institute: pshift.instituteRef,
                                message: { body: nMessage, title: nTitle },
                                provider: {},
                                recipients: recipients,
                                schedule: pshift.schedule,
                                provider_schedule: {
                                    id: selProviderScheduleId,
                                    ref: providerScheduleRef.ref
                                },
                                shift_date: pshift.shift_date,
                                status: 1,
                                type: 'shift_request',
                                shift_request_status: 'pending',
                                request_from: 'admin'
                            });
                            self.spinnerService.hide();
                            Swal({
                                type: 'success',
                                title: 'Provider has been notified for selected date.',
                                showConfirmButton: true,
                                timer: 1500
                            }).then(function (res){
                                self.selectedProviders = [];
                            });
                            self.selProviderScheduleId = '';
                            self.activeDayIsOpen = false;
                            self.showBroadcastPopup = false;
                        }
                    });

                }
            }); */
        }
    }

    addEvent(): void {
        this.events.push({
            title: 'New event',
            start: startOfDay(new Date()),
            end: endOfDay(new Date()),
            color: colors.red,
            draggable: true,
            resizable: {
                beforeStart: true,
                afterEnd: true
            }
        });
        this.refresh.next();
    }
    
    
    addSchedule() {
        this.router.navigate(['/add-schedule']);
    }

    getSchedulesListOldMethod() {
        let objUser = firebase.auth().currentUser;
        let result = [];
        let afs = this.afs;
        let self = this;
        let boxTitle = {};
        let boxDoctors = {};
        let totalDocs = {};
        let totalShiftDocs = {};
        this.view = 'month';
        let obSchedules = [];
        let totalReqDoctors = {};
        let totalAvailDoctors = {};
        /**
         * Get users list
         */
        const userRef = this.afs.collection('users').doc(objUser.uid);
        userRef.valueChanges().subscribe(user => {
            //Get user hospital
            const userHospId = (user['adminFor'] && user['adminFor'].length > 0 && user['adminFor'][0].id)
                ? user['adminFor'][0].id : '';

            //get schedules of hospitals
            self.schedulesRef = afs.collection('schedules', ref => ref.where('instituteRef.id', '==', userHospId).orderBy('name', 'asc'));
            self.schedulesRef.snapshotChanges().map(mapSnapshot).subscribe(schedules => {
                console.log(schedules);
                let promiseArr = [];
                self.scheduleList = schedules;
                self.scheduleFList = schedules;
                if (schedules && schedules.length > 0) {
                    schedules.forEach(schedule => {
                        obSchedules.push({ id: schedule.id, name: schedule.name });
                        let promise = new Promise(function (resolve, reject) {
                            self.shiftsRef = afs.collection('schedules_shifts', ref => ref.where('scheduleRef.id', '==', schedule.id).orderBy('day', 'asc'));
                            self.shiftsRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(scheduleShifts => {
                                console.log(scheduleShifts);
                                if (scheduleShifts && scheduleShifts.length > 0) {
                                    let _scheduleShifts2 = [];
                                    scheduleShifts.forEach(function (scheduleShift) {
                                        scheduleShift['schedule'] = schedule;
                                        _scheduleShifts2.push(scheduleShift);
                                    });
                                    resolve(_scheduleShifts2)
                                } else {
                                    reject('no shifts');
                                }
                            });
                        });
                        promiseArr.push(promise);
                    });
                }
                if (promiseArr.length > 0) {
                    Promise.all(promiseArr)
                        .then(scheduleShifts => {
                            //console.log(scheduleShifts);
                            let _scheduleShifts = [];
                            if (scheduleShifts && scheduleShifts.length > 0) {
                                scheduleShifts.forEach(scheduleShift => {
                                    _scheduleShifts = _scheduleShifts.concat(scheduleShift);
                                })
                            }
                            console.log(_scheduleShifts);
                            let promiseArr2 = [];
                            if (_scheduleShifts && _scheduleShifts.length > 0) {
                                var t = 0;
                                let obDoctors = {};
                                let boxProviderSdls = {};
                                _scheduleShifts.forEach(_scheduleShift => {
                                    //totalReqDoctors = parseInt(_scheduleShift.total_docs);
                                    //totalShiftDocs[_scheduleShift.day] = parseInt(_scheduleShift.total_docs);
                                    if (totalShiftDocs[_scheduleShift.day] && typeof totalShiftDocs[_scheduleShift.day] !== "undefined" && totalShiftDocs[_scheduleShift.day] !== "undefined" && parseInt(totalShiftDocs[_scheduleShift.day]) > 0) {
                                        totalShiftDocs[_scheduleShift.day] = parseInt(totalShiftDocs[_scheduleShift.day]) + parseInt(_scheduleShift.total_docs);
                                        totalReqDoctors[_scheduleShift.day] = parseInt(totalReqDoctors[_scheduleShift.day]) + 1;//parseInt(_scheduleShift.total_docs);
                                    } else {
                                        totalShiftDocs[_scheduleShift.day] = parseInt(_scheduleShift.total_docs);
                                        totalReqDoctors[_scheduleShift.day] = 1;//parseInt(_scheduleShift.total_docs);
                                    }

                                    let docImage = '../../assets/img/provider.png';

                                    let _promise = new Promise(function (resolve, reject) {
                                        if (_scheduleShift.provider && _scheduleShift.provider.id && _scheduleShift.provider.id !== "" && _scheduleShift.provider.id !== "undefined") {
                                            //console.log(_scheduleShift.provider)
                                            self.providerShiftsRef = afs.collection('provider_schedules', ref => ref.where('shift.id', '==', _scheduleShift.id).orderBy('shift_date', 'asc'));
                                            self.providerShiftsRef.snapshotChanges().map(mapSnapshot).take(1).subscribe(shifts => {
                                                let _promiseArr = [];
                                                if (shifts.length > 0) {
                                                    shifts.forEach(function (shift, index) {
                                                        //console.log(shift);
                                                        //set the total no of doctors allowed for the weekly shift
                                                        if (totalAvailDoctors[shift.shift_date_format] && typeof totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] !== "undefined" && totalAvailDoctors[shift.shift_date_format] > 0) {
                                                            totalAvailDoctors[shift.shift_date_format] = parseInt(totalAvailDoctors[shift.shift_date_format]) + 1;
                                                        } else {
                                                            totalAvailDoctors[shift.shift_date_format] = 1;
                                                        }
                                                        // COMMENTING EXTRA DATA
                                                        // boxTitle[_scheduleShift.schedule.id] = '<a class="whtText" href="#/schedule/' +_scheduleShift.schedule.id+'">' + _scheduleShift.schedule.name;
                                                        boxTitle[_scheduleShift.schedule.id] = 'Schedule: ' + _scheduleShift.schedule.name + '<br>Department: ' + _scheduleShift.department + '<br>Shift Type: ' + _scheduleShift.shift_type + '<br>Doc Type: ' + _scheduleShift.doc_type + '<br>ID: ' + _scheduleShift.schedule.id+'<br>';
                                                        boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] = '<br>';
                                                        let bgcolor = colors.green;
                                                        let _promise = new Promise(function (_resolve, _reject) {
                                                            shift.provider.ref.get().then(doc => {
                                                                //console.log(doc);
                                                                if (doc.exists) {
                                                                    shift['provider'] = doc.data();
                                                                    shift['scheduleShift'] = _scheduleShift;
                                                                    if (shift['provider'].photo == '') {
                                                                        shift['provider'].photo = docImage;
                                                                    }
                                                                    //concat doctors info into box
                                                                    boxDoctors[shift.shift.id + '_' + shift.shift_timestamp] += '<ul class="doclist inline-item"><li><a class="whtText" href="#/doctor-profile/' + shift.provider.id + '"><img src="' + shift['provider'].photo + '" /><span class="name">' + shift['provider'].first_name + ' ' + shift['provider'].last_name + '</span></a></li></ul><br>';
                                                                    //push into doctor array

                                                                    let key = shift.shift.id + '_' + shift.shift_timestamp;
                                                                    //let key = shift.shift_date_format;
                                                                    if (!obDoctors[key]) {
                                                                        obDoctors[key] = [];
                                                                    }
                                                                    if (!boxProviderSdls[key]) {
                                                                        boxProviderSdls[key] = [];
                                                                    }
                                                                    obDoctors[key].push({
                                                                        id: shift.provider.id,
                                                                        name: shift['provider'].first_name + ' ' + shift['provider'].last_name,
                                                                        photo: shift['provider'].photo
                                                                    });
                                                                    boxProviderSdls[key].push({ id: shift.id, swap_request: shift.swap_request });
                                                                    //console.log(boxProviderSdls[key]);
                                                                    let bgcolor = colors.green;
                                                                    result.push({
                                                                        start: startOfDay(shift.shift_date),
                                                                        end: endOfDay(shift.shift_date),
                                                                        schedules: obSchedules,
                                                                        title: boxTitle[_scheduleShift.schedule.id] + boxDoctors[shift.shift.id + '_' + shift.shift_timestamp],
                                                                        schedule: _scheduleShift.schedule.name,
                                                                        totalDocs: totalShiftDocs[_scheduleShift.day],
                                                                        doctors: obDoctors[key],
                                                                        provider_schedules: boxProviderSdls[key],
                                                                        color: bgcolor,
                                                                        totalReqDoctors: totalReqDoctors[_scheduleShift.day],
                                                                        totalAvailDoctors: totalAvailDoctors[shift.shift_date_format],
                                                                        resizable: {
                                                                            beforeStart: true,
                                                                            afterEnd: true
                                                                        },
                                                                        draggable: false
                                                                    });
                                                                }
                                                                _resolve(result);
                                                            })
                                                                .catch(err => _reject(err));
                                                        });

                                                        _promiseArr.push(_promise);
                                                    });
                                                }
                                                Promise.all(_promiseArr).then(res => resolve(res)).catch(err => reject(err));
                                            });
                                        } else {
                                            var day = parseInt(_scheduleShift.day);
                                            let startDate = new Date(_scheduleShift.schedule.start_date);

                                            let orginalStartDate = new Date(_scheduleShift.schedule.start_date).getTime();

                                            let endDate = new Date(_scheduleShift.schedule.end_date);
                                            let dayCount = self.CalculateWeekendDays(startDate, endDate, _scheduleShift.day);
                                            //set box content
                                            boxTitle[_scheduleShift.schedule.id] = 'Schedule: ' + _scheduleShift.schedule.name + '<br>Department: ' + _scheduleShift.department + '<br>Shift Type: ' + _scheduleShift.shift_type + '<br>Doc Type: ' + _scheduleShift.doc_type + '<br>ID: ' + _scheduleShift.schedule.id + '<br><br>';
                                            let bgcolor = colors.yellow;
                                            var obDoctor = [];
                                            var day2 = day % 7;
                                            if (day > 6) {
                                                var sday = (day) - (startDate.getDay() || day2);
                                                var loopStartDate = new Date(startDate.getTime() + sday * 86400000);
                                            }
                                            else {
                                                var sday = (day2) - (startDate.getDay() || day2);
                                                var loopStartDate = new Date(startDate.getTime() + sday * 86400000);
                                                //console.log(sday + "===startDate===" + startDate);
                                            }

                                            var dLimit = Math.floor(dayCount / 2);
                                            for (let j = 0; j < dLimit; j++) {
                                                if (j > 0) {
                                                    loopStartDate.setDate(loopStartDate.getDate() + 14);
                                                }
                                                else {
                                                    loopStartDate.setDate(loopStartDate.getDate());
                                                }

                                                if (totalAvailDoctors[self.dateFormat(loopStartDate)] && typeof totalAvailDoctors[self.dateFormat(loopStartDate)] !== "undefined" && totalAvailDoctors[self.dateFormat(loopStartDate)] !== "undefined" && totalAvailDoctors[self.dateFormat(loopStartDate)] > 0) {
                                                } else {
                                                    totalAvailDoctors[self.dateFormat(loopStartDate)] = 0;
                                                }

                                                if (loopStartDate.getTime() >= orginalStartDate && loopStartDate.getDay() == day2) {
                                                    result.push({
                                                        start: startOfDay(loopStartDate),
                                                        end: endOfDay(loopStartDate),
                                                        schedules: obSchedules,
                                                        title: boxTitle[_scheduleShift.schedule.id],
                                                        schedule: _scheduleShift.schedule.name,
                                                        totalDocs: totalShiftDocs[_scheduleShift.day],
                                                        doctors: [],//obDoctor,
                                                        color: bgcolor,
                                                        totalReqDoctors: totalReqDoctors[_scheduleShift.day],
                                                        totalAvailDoctors: totalAvailDoctors[self.dateFormat(loopStartDate)],
                                                        resizable: {
                                                            beforeStart: true,
                                                            afterEnd: true
                                                        },
                                                        draggable: false
                                                    });
                                                }
                                            }
                                            resolve(result)
                                        }
                                    });
                                    t++;
                                    promiseArr2.push(_promise);
                                });
                            }
                            Promise.all(promiseArr2).then(shifts => {
                                let _shifts = [];
                                if (shifts && shifts.length > 0) {
                                    shifts.forEach(function (shift) {
                                        _shifts = _shifts.concat(shift);
                                    });
                                }
                                this.view = 'month';
                            })
                                .catch();
                        })
                        .catch(err => console.log(err))
                }
            });
        });
        console.log(result);
        //this.spinnerService.hide();
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/schedules/schedules.component.ts